import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetInterventionSoilsInputDto, InterventionSoilCreateDto, InterventionSoilDto, InterventionSoilExcelDownloadDto, InterventionSoilUpdateDto } from '../dtos/intervention-soil/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class InterventionSoilService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: InterventionSoilCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionSoilDto>({
      method: 'POST',
      url: '/api/geographic/interventionSoils',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/interventionSoils/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/interventionSoils',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionSoilDto>({
      method: 'GET',
      url: `/api/geographic/interventionSoils/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/interventionSoils/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetInterventionSoilsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InterventionSoilDto>>({
      method: 'GET',
      url: '/api/geographic/interventionSoils',
      params: { interventionId: input.interventionId, interventionName: input.interventionName, isForestPriority: input.isForestPriority, soilArea: input.soilArea, soilAreaFrom: input.soilAreaFrom, soilAreaTo: input.soilAreaTo, soilPercentage: input.soilPercentage, soilPercentageFrom: input.soilPercentageFrom, soilPercentageTo: input.soilPercentageTo, registerId: input.registerId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: InterventionSoilExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/interventionSoils/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, interventionId: input.interventionId, interventionName: input.interventionName, isForestPriority: input.isForestPriority, soilArea: input.soilArea, soilAreaFrom: input.soilAreaFrom, soilAreaTo: input.soilAreaTo, soilPercentage: input.soilPercentage, soilPercentageFrom: input.soilPercentageFrom, soilPercentageTo: input.soilPercentageTo, registerId: input.registerId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionSoilDto[]>({
      method: 'GET',
      url: '/api/geographic/interventionSoils/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionSoilDto>({
      method: 'POST',
      url: `/api/geographic/interventionSoils/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: InterventionSoilUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionSoilDto>({
      method: 'PUT',
      url: `/api/geographic/interventionSoils/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}